import { atom } from 'recoil';

export const refreshCoverablesSelectorAtom = atom<object>({
    key: 'refreshCoverablesSelectorAtom',
    default: {}
});
